import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { Component } from 'react';
import { sectionError } from '~/constants/errorBoundaryEvents';
import { generateErrorLogger } from '~/utilities/loggers';

type OwnProps = {
  children: React.ReactNode;
  location: string;
};

type OwnState = {
  error?: Error;
};

const logError = generateErrorLogger(sectionError);

class EmptyErrorBoundary extends Component<OwnProps, OwnState> {
  static contextType = AnalyticsContext;

  declare context: React.ContextType<typeof AnalyticsContext>;

  constructor(props: OwnProps) {
    super(props);
    this.state = {
      error: undefined
    };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error: Error) {
    const { trackEvent } = this.context;
    const { location } = this.props;
    const payload = {
      error: error.message,
      stack: error.stack
    };
    trackEvent('criticalAppError', payload);

    logError(error, { location: `${location} Error Boundary` });
  }

  render() {
    const { error } = this.state;

    return error ? <div /> : this.props.children;
  }
}

export default EmptyErrorBoundary;
